import type { LogicFilterGroup, LogicFilterNode } from '../../fetchSurvey/types/survey';
import type { LogicContext } from '../types';
import { evaluateLeafFilter } from './evaluateLeafFilter';

function isGroup(node: LogicFilterNode): node is LogicFilterGroup {
  return 'filters' in node && Array.isArray(node.filters);
}

export function evaluateCondition(node: LogicFilterNode, context: LogicContext): boolean {
  if (isGroup(node)) {
    if (node.filterType === 'AND') {
      return node.filters.every(child => evaluateCondition(child, context));
    }
    if (node.filterType === 'OR') {
      return node.filters.some(child => evaluateCondition(child, context));
    }
    return false;
  }

  return evaluateLeafFilter(node, context);
}
